import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { api } from '~/lib/api';

/** Состояние лендинга (add-promo-landing): участие и баланс козочек вошедшего участника. */

export const LANDING_STATE_KEY = ['landing', 'state'] as const;

export function useLandingState() {
  return useQuery({ queryKey: LANDING_STATE_KEY, queryFn: api.landing.state, retry: false });
}

export function useConfirmParticipation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: api.landing.confirmParticipation,
    onSuccess: () => qc.invalidateQueries({ queryKey: LANDING_STATE_KEY }),
  });
}
